// extracted by mini-css-extract-plugin
export default {"fullHeightLayout":"App_fullHeightLayout__SCzQ3","fullHeightItem":"App_fullHeightItem__6JylI"};